// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './assets/css/mian.css'
import 'animate.css'
import url from './config/url'
Vue.prototype.$url = url;
import db from './api/db'
Vue.use(db)
import WtDataList from '_c/dataList/lists.js'
import WtDataTable from '_c/dataTable/dataTable.js'
import WtDataModal from '_c/dataModal/dataModal.js'
Vue.use(WtDataList)
Vue.use(WtDataTable)
Vue.use(WtDataModal)
import WtDataArea from '_c/dataArea/dataArea.js'
import WtPoster from '_c/poster/poster.js'
Vue.use(WtDataArea)
Vue.use(WtPoster)

import WtFooter from '_c/footer/footer.js'
Vue.use(WtFooter)
import Captcha from '@kkokk/captcha'
Vue.use(Captcha)
import ElementUI from 'element-ui';
import { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import moment from 'moment';

import echarts from 'echarts'
require('echarts/map/js/china')

Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})


import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
const JWT_KEY = "20111YIRANloveeYIENN20188BAmaaaa"
Vue.prototype.createToken = ({ data }) => {
  const jwt = require("jsonwebtoken");
  let token = jwt.sign(data, JWT_KEY, { expiresIn: 60 * 60 });
  return token;
}

import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
Vue.component('vue-ueditor-wrap', VueUeditorWrap)

store.dispatch('getDictList')

Vue.prototype.dateFormat = (date, fmt) => {
  let now = new Date(date)
  var o = {
    "M+": now.getMonth() + 1,                 //月份
    "d+": now.getDate(),                    //日
    "h+": now.getHours(),                   //小时
    "m+": now.getMinutes(),                 //分
    "s+": now.getSeconds(),                 //秒
    "q+": Math.floor((now.getMonth() + 3) / 3), //季度
    "S": now.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (now.getFullYear() + "").substring(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substring(("" + o[k]).length)));
  return fmt;
}

let loading
Vue.prototype.ViewLoading = (message = "数据加载中") => {
  loading = Loading.service({
    lock: true,
    text: '数据加载中',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
Vue.prototype.CloseViewLoading = () => {
  loading.close()
}

Vue.prototype.doLogin = ({ success }) => {
  let userInfo = store.state.user_info
  if (userInfo) {
    success && success(userInfo)
  } else {
    //未登录的情况
    //判断当前的路由是否是目标路由
    if (router.currentRoute.name !== "login") {
      //跳转回login路由，并把目标路由的url路径保存在login的query中
      router.replace({
        name: "login",
        query: { redirect: router.currentRoute.fullPath }
      })
    } else {
      /* 普通401拦截直接返回到登录页面 */
      router.push('/login');
    }
  }
}
//document.onselectstart = function () { return false; }
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js